import axios from 'axios'
import { AUTH_HEADERS, AUTH_HEADERS_BLOB } from '../utils/config'
export default {
  get (limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderDocument/all?limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  getByTask (taskId) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderDocument/task/${taskId}`, AUTH_HEADERS())
  },
  getUrl (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderDocument/url/${id}`, AUTH_HEADERS())
  },
  getFile (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderDocument/file/${id}`, AUTH_HEADERS_BLOB())
  },
  create (document) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrderDocument`, document, AUTH_HEADERS())
  },
  update (document) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrderDocument/${document.id}`, document, AUTH_HEADERS())
  },
  upload (object) {
    let formData = new FormData()
    formData.append('file', object.file)
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrderDocument/upload/${object.id}`, formData, AUTH_HEADERS())
  },
  uploadCreate (object) {
    let formData = new FormData()
    formData.append('file', object.file)
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrderDocument/createUpload?workOrderTaskId=${object.workOrderTaskId}&userId=${object.userId}&stage=${object.stageCreatedAt}`, formData, AUTH_HEADERS())
  },
  deleteDocument (id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}workOrderDocument/remove/${id}`, AUTH_HEADERS())
  }
}
